/* KBW FAQ — the tab strip.

   The accordion underneath needs no script at all: it is built from <details>
   elements sharing a `name`, which the browser already treats as a group where
   opening one closes the rest. The previous theme pulled jQuery off a CDN to
   do that by hand.

   What is left for JavaScript is switching panels. Until it runs the markup
   already makes sense — every panel is present, the first one visible — and a
   <noscript> block in the section shows the rest and hides the strip, so with
   scripting off the page is a plain list of every question rather than one
   fifth of them.

   Markup contract:
     [data-kbw-faq]        the section root
     [role="tablist"]      the strip
     [role="tab"]          a tab, with aria-controls pointing at its panel
     [role="tabpanel"]     a panel, hidden unless its tab is selected
*/

(function () {
  'use strict';

  function setup(root) {
    if (root.dataset.kbwFaqReady === '1') return;

    var tabs = root.querySelectorAll('[role="tab"]');
    if (tabs.length < 2) return;

    root.dataset.kbwFaqReady = '1';
    root.classList.add('is-enhanced');

    function select(tab) {
      for (var i = 0; i < tabs.length; i++) {
        var current = tabs[i] === tab;
        tabs[i].setAttribute('aria-selected', current ? 'true' : 'false');
        /* Only the selected tab stays in the tab order. Arrow keys move
           between them from there, which is how a tab strip is expected to
           behave with a keyboard. */
        tabs[i].tabIndex = current ? 0 : -1;

        var panel = document.getElementById(tabs[i].getAttribute('aria-controls'));
        if (panel) panel.hidden = !current;
      }
    }

    for (var i = 0; i < tabs.length; i++) {
      (function (tab, index) {
        tab.addEventListener('click', function () {
          select(tab);
        });

        tab.addEventListener('keydown', function (event) {
          var step = 0;
          if (event.key === 'ArrowRight') step = 1;
          else if (event.key === 'ArrowLeft') step = -1;
          else if (event.key === 'Home') step = -index;
          else if (event.key === 'End') step = tabs.length - 1 - index;
          else return;

          event.preventDefault();
          var next = (index + step + tabs.length) % tabs.length;
          select(tabs[next]);
          tabs[next].focus();
        });
      })(tabs[i], i);
    }
  }

  function setupAll() {
    var roots = document.querySelectorAll('[data-kbw-faq]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  // The theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', setupAll);
})();
